import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import { Page } from '../../../components/page/Page'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import { routes } from '../../../constants'
import utils, { getMessage } from '../../../utils/index'
import _ from 'lodash'

import {
  changeFavorito,
  componentDidMount,
  componentDidUpdate,
  loadFavorito,
  onColumnReorder,
  onColumnToggle,
  onCsvExport,
  onPage,
  onSort,
} from '../../../utils/listPageContainerUtils'
import { actions } from '../certificadoDigital.actions'
import { CertificadoDigitalList } from './CertificadoDigitalList'
import '../../../index.scss'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'

const mapStateToProps = (state) => {
  return {
    showHideColumns: state.crudCertificadoDigitalState.showHideColumns,
    messages: state.crudCertificadoDigitalState.messages,
    columns: state.crudCertificadoDigitalState.columns,
    records: state.crudCertificadoDigitalState.records,
    isLoadingRecords: state.crudCertificadoDigitalState.isLoadingRecords,
    first: state.crudCertificadoDigitalState.index,
    rows: state.crudCertificadoDigitalState.max,
    totalRecords: state.crudCertificadoDigitalState.count,
    sortField: state.crudCertificadoDigitalState.sortField,
    order: state.crudCertificadoDigitalState.sortOrder,
    selectedFilters: state.crudCertificadoDigitalState.selectedFilters,
    ativoBooleanTypes: state.crudCertificadoDigitalState.ativoBooleanTypes,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    changeFilter: (column, e) => {
      const target = e.target
      let campo = column.fieldJoin ? column.fieldJoin : target.name
      dispatch(actions.setSelectedFilters(campo, target.value, column.relacionamento, column.field))
      setTimeout(() => {
        dispatch(actions.executeFilter(`/lottustech/certificadosdigitais/all`))
      }, 400)
    },
    load: () => dispatch(actions.load()),
    setColumns: (columns) => dispatch(actions.loadColumns(columns)),
    loadFavorito: (menu) => {
      dispatch(actions.loadFavorito(menu))
    },
    removeFavorito: (menu) => {
      dispatch(actions.removeFavorito(menu))
    },
    adicionarFavorito: (menu) => {
      dispatch(actions.adicionarFavorito(menu))
    },
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
    exportarDadosCSV: () => {
      dispatch(actions.exportCSV())
    },
    getTemplateImportacao: () => {
      dispatch(actions.getTemplateImportacao())
    },
    uploadCsvImportacao: (arquivo) => {
      dispatch(actions.uploadCsvImportacao(arquivo))
    },
  }
}

class CertificadoDigitalListPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableRef = React.createRef()
    this.columnSelect = React.createRef()
    this.showHideColumns = []
    this.state = {
      dadosFavorito: null,
      favorito: 0,
    }
    this.onColumnToggle = this.onColumnToggle.bind(this)
  }

  onColumnToggle(event) {
    onColumnToggle(event, this)
  }

  onColReorder(e, colunasAtuais) {
    onColumnReorder(e, colunasAtuais, this)
  }

  exportar(excel = true) {
    onCsvExport(this.props.records, this, actions, excel)
  }

  loadFavorito() {
    loadFavorito(this, actions)
  }

  changeFavorito() {
    changeFavorito(this, actions)
  }

  newHandler = () => {
    this.props.history.push(`${routes.PATH_CERTIFICADO_DIGITAL}/novo`)
  }

  componentDidMount() {
    componentDidMount(this)
  }

  componentDidUpdate(prevProps, prevState) {
    componentDidUpdate(this, prevProps, prevState)
  }

  onPage = (e) => {
    onPage(this, e)
  }

  onSort = (e) => {
    onSort(this, e)
  }

  buildHeader = () => {
    return (
      <DefaultToolBar
        listPageContainer={this}
        title={getMessage(this.props.messages, 'certificadodigital.label.certificadosdigitais')}
      />
    )
  }

  oid = (rowData) => {
    return <Link to={`${routes.PATH_CERTIFICADO_DIGITAL}/${rowData.oid}`}>{rowData.oid}</Link>
  }

  titular = (rowData) => {
    return _.get(rowData, 'titularCommonName', '')
  }

  emissor = (rowData) => {
    return _.get(rowData, 'emissorCommonName', '')
  }

  fieldFilter = (column) => {
    return (
      <InputText
        style={{ width: '100%' }}
        name={column.field}
        value={this.props.selectedFilters[column.field]}
        onChange={(e) => this.props.changeFilter(column, e)}
      />
    )
  }

  formatColumn = (rowData, column) => {
    return utils.format(rowData, column)
  }

  ativoTemplate = (rowData, column) => {
    return column.field === 'ativo' && rowData[column.field] ? 'Sim' : 'Não'
  }

  booleanFilter = (column) => {
    return (
      <Dropdown
        style={{ width: '100%', minWidth: '10px' }}
        name={column.field}
        value={_.get(this.props.filterValues, [column.field, 'valor'])}
        options={this.props.ativoBooleanTypes}
        onChange={(e) => {
          _.set(this.props.filterValues, [column.field, 'valor'], e.value)
          this.props.changeFilter(column, e)
        }}
      />
    )
  }

  fieldCalendarFilter = (column) => {
    return (
      <Calendar
        value={_.get(this.props.filterValues, [column.field, 'valor'])}
        yearNavigator={true}
        monthNavigator={true}
        yearRange={utils.getYearRangeFromDate('1900')}
        appendTo={document.body}
        showButtonBar={true}
        onChange={(e) => this.props.changeFilter(column, e)}
        name={column.field}
      />
    )
  }

  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      if (col.field === 'oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.oid}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-oid-body-width"
            filterHeaderClassName="table-column-oid-filter-header-width"
            headerClassName="table-column-oid-header-width"
          />
        )
      }

      if (col.field === 'titularCommonName') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.titular}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-titular-body-width"
            filterHeaderClassName="table-column-titular-filter-header-width"
            headerClassName="table-column-titular-header-width"
          />
        )
      }

      if (col.field === 'emissorCommonName') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.emissor}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-emissor-body-width"
            filterHeaderClassName="table-column-emissor-filter-header-width"
            headerClassName="table-column-emissor-header-width"
          />
        )
      }

      if (col.field === 'unidade_sigla') {
        return <Column {...col} key={col.field} sortField={col.columnSortField} filterElement={this.fieldFilter(col)} />
      }

      if (col.field === 'ativo') {
        return (
          <Column
            {...col}
            key={col.field}
            filterHeaderStyle={{ overflow: 'visible' }}
            sortField={col.columnSortField}
            body={this.ativoTemplate}
            filterElement={this.booleanFilter(col)}
            bodyClassName="table-column-ativo-body-width"
            filterHeaderClassName="table-column-ativo-filter-header-width"
            headerClassName="table-column-ativo-header-width"
          />
        )
      }

      if (col.field === 'dataInicio' || col.field === 'dataExpiracao') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.formatColumn}
            sortField={col.columnSortField}
            filterElement={this.fieldCalendarFilter(col)}
            bodyClassName="column-date-body-width"
            filterHeaderClassName="column-date-filter-header-width"
            headerClassName="column-date-header-width"
          />
        )
      }

      return <Column {...col} key={col.field} sortField={col.columnSortField} filterElement={this.fieldFilter(col)} />
    })
  }

  buildContent = () => {
    return (
      <CertificadoDigitalList
        {...this.props}
        dataTableRef={(el) => (this.dataTableRef = el)}
        onColReorder={(e) => this.onColReorder(e, this.showHideColumns)}
        onPage={this.onPage}
        onSort={this.onSort}
        columns={this.defineColumns()}
      />
    )
  }

  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      // O LoadingSpinner abaixo so cobre a primeira montagem, quando ainda nao ha colunas.
      // Depois disso paginar/ordenar/filtrar refaz a consulta com a grade ja na tela: o
      // `loading` do Page vela so a grade, sem prender o menu nem a toolbar.
      return <Page header={this.buildHeader()} content={this.buildContent()} loading={this.props.isLoadingRecords} />
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CertificadoDigitalListPageContainer)
